/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcAddSmallRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M11.1 18a.9.9 0 0 0 1.8 0v-5.1H18a.9.9 0 1 0 0-1.8h-5.1V6a.9.9 0 1 0-1.8 0v5.1H6a.9.9 0 1 0 0 1.8h5.1z" />
    </svg>
  );
}
export default IcAddSmallRegular;
